// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7506d987b5--container--G5Ryv","seo-text":"_7506d987b5--seo-text--urc4H"};